import { ofType, combineEpics, } from 'redux-observable';
import {
  pluck, filter, flatMap, tap, ignoreElements, take, switchMap,
} from 'rxjs/operators';
import { actions, socket$, } from '@ezugi/bootstrap';
import {
  INITIAL_DATA, GAME_RESULT, CARD, CANCEL_LAST_CARD, WON_BETS, PLACE_YOUR_BETS, NO_MORE_BETS,
} from '@ezugi/constants';
import { Card, } from '@ezugi/primitives';

import handleInitialData from './handleInitialData';
import handleGameResult from './handleGameResult';
import handleCardMessage from './handleCardMessage';
import handleCancelLastCard from './handleCancelLastCard';
import handleWonBets from './handleWonBets';
import handlePlaceYourBets from './handlePlaceYourBets';
import handleNoMoreBets from './handleNoMoreBets';

const { socketActions: { socket, }, videoActions: { video, }, } = actions;

function initialDataEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === INITIAL_DATA),
    flatMap((socketMessage) => handleInitialData(socketMessage, state$.value))
  );
}

function placeYourBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === PLACE_YOUR_BETS),
    flatMap(() => handlePlaceYourBets(state$.value))
  );
}

function noMoreBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === NO_MORE_BETS),
    flatMap(() => handleNoMoreBets(state$.value))
  );
}

function gameResultEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === GAME_RESULT),
    flatMap((socketMessage) => handleGameResult(socketMessage, state$.value))
  );
}

function cardMessageEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === CARD),
    flatMap((socketMessage) => handleCardMessage(socketMessage, state$.value))
  );
}

function cancelLastCardEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === CANCEL_LAST_CARD),
    flatMap((socketMessage) => handleCancelLastCard(socketMessage, state$.value))
  );
}

function preloadCardEpic(action$) {
  return action$.pipe(
    ofType(video.set),
    take(1),
    pluck('payload', 'cdnList', 'videoDelay'),
    switchMap(
      (delay) => (+delay
        ? socket$.pipe(
          filter(({ MessageType, }) => MessageType === CARD),
          pluck('CardName'),
          tap(Card.preload)
        )
        : socket$.pipe(
          take(1),
          tap(() => {
            Card.preloadAll();
          })
        ))
    ),
    ignoreElements()
  );
}

function wonBetsEpic(action$, state$) {
  return action$.pipe(
    ofType(socket.message),
    pluck('payload'),
    filter(({ MessageType, }) => MessageType === WON_BETS),
    flatMap((socketMessage) => handleWonBets(socketMessage, state$.value))
  );
}

export default combineEpics(
  gameResultEpic,
  cardMessageEpic,
  preloadCardEpic,
  cancelLastCardEpic,
  initialDataEpic,
  wonBetsEpic,
  placeYourBetsEpic,
  noMoreBetsEpic,
);
